/*----------------------------------------------------------------------------*\
    Analysis
    Analysis of photo folders, powered by dhtmlx treegrid
\*----------------------------------------------------------------------------*/

/**
 * Use strict as per:
 * http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/
 */
'use strict';


/**
 * Check if oy object exists, otherwise create it
 */
var oy = oy || {};

var checked = [];

var lastopened = '';

var exportToExcelUrl = '';

/**
 * Jshint global references
 * Please define all third party plugins that you use to not break jshinting
 */
/*global dhtmlXGridObject */
/*global eXcell */

/* eslint-disable camelcase */
function eXcell_gauge (cell) {
    if (cell) {
        this.cell = cell;
        this.grid = this.cell.parentNode.grid;
    }
    this.edit = function () {};
    this.isDisabled = function () {
        return true;
    };
    this.setValue = function (val) {
        if (!isNaN(val)) {
            var className = 't-background--state-success-a';
            if (val >= 80) {
                className = 't-background--state-success-a';
            } else if (val < 80 && val >= 50) {
                className = 't-background--state-warning-a';
            } else if (val < 50) {
                className = 't-background--state-error-a';
            }
            this.setCValue('<div class="c-gauge"><div class="c-gauge__bar '+className+'" style="width: '+val+'%">'+val+'%</div></div>', val);
        } else {
            this.setCValue(val, val);
        }
    };
}

eXcell_gauge.prototype = new eXcell;
/* eslint-enable camelcase */



/*  Component
\*----------------------------------------------------------------------------*/

oy.analysis = {

    init: function(){
        if (oy.cutsMustard) {
            this.setup(document);
        }
    },


    setup: function ($context) {
        var self = this;
        if ($context) {
            var $elements = $context.querySelectorAll('.js--analysis');
            for (var i = 0; i < $elements.length; ++i) {
                var $element = $elements[i];
                self.setupSingle($element);
            }
        }
    },

    setupSingle: function ($context) {
        var self = this;
        var $table = $context.querySelector('.js--analysis__table');
        if ($table && !$table.classList.contains('is-initialised') && $table.getAttribute('data-images-url') && $table.getAttribute('data-ajax-url') && $table.getAttribute('data-ajax-url-kids') && $table.getAttribute('data-headers') && $table.getAttribute('data-column-ids')) {
            var treeGrid = new dhtmlXGridObject($table);
            
            exportToExcelUrl = $table.getAttribute('data-ajax-url-export-excel');
            treeGrid.setImagePath($table.getAttribute('data-images-url'));
            treeGrid.setHeader($table.getAttribute('data-headers'));
            treeGrid.setColumnIds($table.getAttribute('data-column-ids'));
            treeGrid.setColTypes('ch,tree,txt,txt,txt,txt,txt,txt,txt,txt,txt,txt,txt,txt,gauge');
            treeGrid.setInitWidths('36,170,90,60,70,80,80,70,80,40,60,50,70');
            treeGrid.setColAlign('left,left,right,right,right,right,right,right,right,right,right,right,right,right,left');
            treeGrid.enableAutoWidth(true);
            treeGrid.enableTreeCellEdit(false);
            treeGrid.enableEditEvents(false,false,false);
            

            treeGrid.attachEvent('onOpenStart', function (id, m) {
                oy.loader.open($context);
                return m;
            });

            treeGrid.attachEvent('onOpenEnd', function (id, m) {
                oy.loader.close($context);
                self.adjustHeight($table);
                lastopened = id;
                return m;
            });

            treeGrid.attachEvent('onXLE', function () {
                if(lastopened !== '') {
                    handleSelect(lastopened,treeGrid.cells(lastopened,0).getValue() === '1' ? true : false);
                }
                self.adjustHeight($table);
            });

            treeGrid.attachEvent('onBeforeSelect', function(newRow){
                handleSelect(newRow,treeGrid.cells(newRow,0).getValue() === '1' ? false : true);
                return false;
            });

            treeGrid.attachEvent('onResizeEnd', function () {
                self.adjustHeight($table);
            });

            treeGrid.attachEvent('onResize', function () {
                self.adjustHeight($table);
                return true;
            });

            treeGrid.attachEvent('onCheck', function(rId,cInd,state){
                handleSelect(rId,state);
                return false;
            });

            treeGrid.init();
            $table.classList.add('is-initialised');
            treeGrid.kidsXmlFile = $table.getAttribute('data-ajax-url-kids');
            treeGrid.load($table.getAttribute('data-ajax-url'), this.onDataLoaded);

            // Handle selection
            var handleSelect = function (rId,state) {
                addOrRemoveElement(rId, state);

                // check / uncheck all child folders
                SetStateOffAllChildren(rId, state);

                // Set Parents recursive
                var parent = treeGrid.getParentId(rId);
                while(parent !== 0) {
                    SetStateBasedOnChildren(parent, state);
                    parent = treeGrid.getParentId(parent);
                }

                // Enable / Disable earnings per folder button
                if(checked.length > 0 && document.getElementById('ShowEarnings').hasAttribute('disabled')) {
                    document.getElementById('ShowEarnings').removeAttribute('disabled');
                } else if(checked.length === 0 && !document.getElementById('ShowEarnings').hasAttribute('disabled')) {
                    document.getElementById('ShowEarnings').setAttribute('disabled', '');
                }
            };

            // handle checkbox and keep track in array
            var addOrRemoveElement = function (id, add) {
                if (add) {
                    SetSingleChecked(id);
                }
                else {
                    SetSingleUnChecked(id);
                }
            };

            // Set single checked
            var SetSingleChecked = function (rId) {
                treeGrid.setRowColor(rId,'#ebebeb');
                if(!checked.includes(rId)) {
                    checked.push(rId);
                }
                treeGrid.cells(rId,0).setValue(true);
                treeGrid.cells(rId,0).cell.className = 'checked';
            };

            // Set single as partial
            var SetSinglePartial = function (rId) {
                treeGrid.setRowColor(rId,'#ebebeb');
                if(checked.includes(rId)) {
                    checked.splice(checked.indexOf(rId), 1);
                }
                treeGrid.cells(rId,0).setValue(false);
                treeGrid.cells(rId,0).cell.className = 'partial';
            };

            // Set single unChecked
            var SetSingleUnChecked = function (rId) {
                treeGrid.setRowColor(rId,'#ffffff');
                if(checked.includes(rId)) {
                    checked.splice(checked.indexOf(rId), 1);
                }
                treeGrid.cells(rId,0).setValue(false);
                treeGrid.cells(rId,0).cell.className = '';
            };

            // Update all children on parent clicked
            var SetStateOffAllChildren = function (rId, state) {
                var children = treeGrid.getAllSubItems(rId).split(',');
                children.forEach(element => {
                    if(element !== '') {
                        addOrRemoveElement(element, state);
                    }
                });
            };

            // Set Parent Recursive
            var SetStateBasedOnChildren = function (rId, state) {
                var children = treeGrid.getSubItems(rId).split(',');

                // Uncheck action
                if(state === false) {
                    // Try to find a child which is partial or checked
                    let isPartial = children.find(function(element) {
                        return treeGrid.cells(element,0).cell.className !== '';
                    });

                    if(isPartial) {
                        // Found, cell is partial
                        SetSinglePartial(rId);
                    }
                    else {
                        // Didn't find, cell is unchecked
                        SetSingleUnChecked(rId);
                    }
                }

                // Check Action
                if(state === true) {
                    // Try to find a child which is partial or unchecked
                    let isPartial = children.find(function(element) {
                        return treeGrid.cells(element,0).cell.className !== 'checked';
                    });

                    if(isPartial) {
                        // Found, cell is partial
                        SetSinglePartial(rId);
                    }
                    else {
                        // Didn't find, cell is checked
                        SetSingleChecked(rId);
                    }
                }
            };

            // Bind function to showEarnings button
            document.getElementById('ShowEarnings').addEventListener('click', function(event){
                event.preventDefault();
                var onlyWithInactiveParent = [];

                checked.forEach(function(element)
                {
                    var parent = treeGrid.getParentId(element);
                    if(parent === 0 || !checked.includes(parent)) {
                        onlyWithInactiveParent.push(parseInt(element.substring(1)));
                    }
                });

                window.location.href = document.getElementById('ShowEarnings').getAttribute('href') + '?ids=' + onlyWithInactiveParent;
            });

            document.getElementById('ToExcel').addEventListener('click', function(event){
                event.preventDefault();                
                treeGrid.toExcel(exportToExcelUrl);                
            });


           /* document.getElementById('ExpandAll').addEventListener('click', function(event){
                event.preventDefault();
                openAllItems(treeGrid, 0);
                
            });

            document.getElementById('CollapseAll').addEventListener('click', function(event){
                event.preventDefault();
                treeGrid.collapseAll();
            }); */

            function openTreeItems(grid, parentId) {
                // Get all child IDs of the current parent
                var childIds = grid.getAllSubItems(parentId).split(',');
                
                // Open each child item and recurse
                for (var i = 0; i < childIds.length; i++) {
                    var childId = childIds[i];
                    if (childId) { // Check if the childId is valid
                        grid.openItem(childId);
                        openAllItems(grid, childId); // Recursive call to open child items
                    }
                }
            }
        }
    },
    
  

    adjustHeight: function ($context) {
        if ($context && $context.classList.contains('is-initialised')) {
            var headerHeight = $context.querySelector('.xhdr').offsetHeight;
            var $box = $context.querySelector('.objbox');
            var contentHeight = $box.querySelector('table').offsetHeight;

            $box.style.height = contentHeight + 'px';

            $context.style.height = headerHeight + contentHeight + 'px';
        }
    },

    onDataLoaded: function(){
        oy.loader.close(document.querySelector('.js--analysis'));
    },

   


};


window.addEventListener('load', function () {
    oy.analysis.init();
    oy.loader.open(document.querySelector('.js--analysis'));
}, false);

